export default [
  {
    path: '/202103-public-invitation',
    name: '202103-public-invitation',
    component: () =>
      import(
        /* webpackChunkName: "202103-public-invitation" */ '@/views/202103-public-invitation/index.vue'
      ),
    meta: {
      title: 'VIPKID 数学思维'
    }
  }
]
